<template>
    <div class="space-y-4">
        <vue-signature-pad
        ref="signaturePad"
        :options="{ penColor: '#000' }"
        class="border w-full rounded bg-white"
        style="height: 200px;"
        ></vue-signature-pad>
        
        <div class="flex items-center gap-6 justify-between text-lg">
            <button @click="clear" class="px-4 py-2 bg-gray-200 rounded">
                <i class="fas fa-redo-alt"></i>
            </button>
            <button @click="save" :class="btnClass">{{ btnLabel }}</button>
        </div>
        
        <div v-if="progress > 0 && progress < 100" class="text-sm">
            Upload : {{ progress }}%
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "InputSignature",
    props: {
        value: { type: String, default: null },
        keyName: { type: String, required: true },
        btnLabel: { type: String, default: "Enregistrer" },
        btnClass: { type: String, default: "px-4 py-2 bg-red-600 text-white rounded" },
    },
    data() {
        return {
            progress: 0,
        };
    },
    methods: {
        clear() {
            this.$refs.signaturePad.clearSignature();
        },

        async save() {
            if (this.$refs.signaturePad.isEmpty()) {
                this.$toast.error("Signature obligatoire");
                return;
            }

            // Base64 directement
            const dataUrl = this.$refs.signaturePad.saveSignature();
            const blob = this.dataURLtoBlob(dataUrl);

            const formData = new FormData();
            formData.append("file", blob, "signature.png");
            formData.append("key_name", this.keyName);

            try {
                const response = await axios.post(
                    "https://storage.termoflow.fr/upload.php",
                    formData,
                    {
                        headers: {
                            "Authorization": "Bearer PRODt1ntH4nCMTfw5tGrXy0ZRgyz4Q",
                            "Content-Type": "multipart/form-data"
                        },
                        onUploadProgress: (progressEvent) => {
                            if (progressEvent.lengthComputable) {
                                this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            }
                        }
                    }
                );

                if (response.data && response.data.success) {
                    this.$emit("input", response.data.url);
                } else {
                    throw new Error("Upload échoué");
                }

            } catch (err) {
                console.error(err);
                this.$toast.error("Erreur lors de l'upload de la signature.");
            }
        },

        dataURLtoBlob(dataUrl) {
            // Exemple dataUrl: "data:image/png;base64,AAAA..."
            if (!dataUrl || !dataUrl.data) return null;
            const arr = dataUrl.data.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new Blob([u8arr], { type: mime });
        }
    }
};
</script>
